import React, { useState } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { Button, Text } from "components/ui/source";

import { IconUpChevron, IconDownChevron } from "icons";

import AdaAccessibility from "./AdaAccessibility";

import styles from "./Features.module.scss";

function Features({ className, adaAccessibilityInfo, amenities }) {
  const [open, setOpen] = useState(false);
  const OpenIcon = open ? IconUpChevron : IconDownChevron;

  if (!amenities || amenities.length == 0) return null;

  const featureElements = amenities
    .filter(amenity => amenity.active)
    .map(amenity => (
      <li key={amenity.name} className={styles.feature}>
        <Text className={styles.feature} types={["body1"]}>
          {amenity.label}
        </Text>
      </li>
    ));
  featureElements.push(
    <AdaAccessibility
      key="ada_accessability"
      className={styles.feature}
      {...adaAccessibilityInfo}
    />,
  );
  const half = Math.floor(featureElements.length / 2);

  return (
    <div className={className}>
      <Button
        className={styles.toggle_button}
        type="no_background"
        onClick={() => setOpen(!open)}
      >
        <Text
          className={styles.title}
          types={["body1", "medium"]}
          translateKey="listing:availability.collection.features"
        />
        <OpenIcon className={styles.icon} size="sm" />
      </Button>
      <div className={classnames(styles.features, open && styles.opened)}>
        <ul className={styles.feature_list}>
          {featureElements.slice(0, half)}
        </ul>
        <ul className={styles.feature_list}>
          {featureElements.slice(half, featureElements.length)}
        </ul>
      </div>
    </div>
  );
}

Features.propTypes = {
  className: PropTypes.string,
  amenities: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      label: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  adaAccessibilityInfo: PropTypes.shape({
    isHearingAccessible: PropTypes.bool.isRequired,
    isMobilityAccessible: PropTypes.bool.isRequired,
    mobilityFeatures: PropTypes.array,
    hearingFeatures: PropTypes.array,
  }),
};

export default Features;
